import { isOptimizerTimeoutError } from '@/optimizer/helpers/withOptimizerTimeout';

const runtimeErrorShape = (error: unknown): { code: string; message: string } | null => {
    if (!error || typeof error !== 'object') return null;
    const { code, message } = error as { code?: unknown; message?: unknown };
    return typeof code === 'string' && typeof message === 'string' ? { code, message } : null;
};

// A Pyodide PythonError message is the whole traceback; the last line is the exception itself.
const lastTracebackLine = (message: string): string =>
    message.includes('Traceback (most recent call last)')
        ? (message.trim().split('\n').at(-1)?.trim() ?? message)
        : message;

// The worker rejects with a plain OptimizerRuntimeErrorShape object (not an Error) across Comlink;
// without this the modal reads "[object Object]" and the Python exception is lost.
export const toError = (error: unknown): Error => {
    if (isOptimizerTimeoutError(error)) return error;
    if (error instanceof Error) {
        return error.message.includes('Traceback (most recent call last)')
            ? new Error(lastTracebackLine(error.message), { cause: error })
            : error;
    }
    const shape = runtimeErrorShape(error);
    if (shape) return new Error(`[${shape.code}] ${lastTracebackLine(shape.message)}`, { cause: error });
    return new Error(String(error));
};
